module.exports = __webpack_public_path__ + "../resources/img/bg_pictogram_motion01.0ffcfbed.png";